// extracted by mini-css-extract-plugin
export default {"intro":"WebHosting-intro_SeEIo"};